import api from './api';
import types from './mutation-types';
import moment from 'moment';

function getRowKey() {
	return moment.now().toString();
}

export default {
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setCmpnMstInit_({ commit }) {
		commit(types.STATE_CMPN_MST_INIT);
	},
	setOpCdPopupSearchInit_({ commit }) {
		commit(types.OP_CD_SEARCH_PARAMS_INIT);
	},
	setOpCdPopupSearchParams_({ commit }, { key, value }) {
		commit(types.OP_CD_SEARCH_PARAMS, { key, value });
	},
	setCmpnMstPopup_({ commit }, { key, value }) {
		commit(types.CMPN_MST_POPUP, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.PAGING_INFO, { key, value });
	},
	setPopUpPagingInfo_({ commit }, { key, value }) {
		commit(types.POP_UP_PAGING_INFO, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	postSelectList_({ commit }) {
		return api
			.postSelectList()
			.then(data => {
				if (data.header.code === 0) {
					//발생지역 콤보박스
					// commit(types.DEFAULT_ASSIGN, {
					// 	key: 'occuRegnListPop',
					// 	value: data.body.OCCU_REGN || []
					// });
					//문제유형 콤보박스
					commit(types.DEFAULT_ASSIGN, {
						key: 'prbmTypeListPop',
						value: data.body.PRBM_TYPE || []
					});
					//캠페인유형 콤보박스
					commit(types.DEFAULT_ASSIGN, {
						key: 'cmpnTypeListPop',
						value: data.body.CMPN_TYPE || []
					});
					//기종 콤보박스
					commit(types.DEFAULT_ASSIGN, {
						key: 'tymaCdListPop',
						value: data.body.FLCL_SPC || []
					});
					//원인코드 콤보박스
					commit(types.DEFAULT_ASSIGN, {
						key: 'causCdListPop',
						value: data.body.CAUS_CD || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//캠페인 목록
	getCmpnMstList_({ commit, state }) {
		//actions,getters,mutaions는 첫번째 인자로 store안에,commit,state,dispatch

		const { searchParams, pagingInfo } = state;

		return api
			.getCmpnMstList({ searchParams: searchParams, currentPage: pagingInfo.currentPage, pageUnit: pagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'cmpnMstList',
						value: data?.body.resultList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pagingInfo',
						value: data?.body.pagingInfo
					});
					/*
					commit(types.DEFAULT_ASSIGN, {
						key: 'excelDownLoadList',
						value: data?.body.selectSamPleExcelList || []
					});
					*/
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//캠페인 상세 팝업 조회
	getCmpnMstPopList_({ commit, state }, param) {
		return api
			.getCmpnMstPopList(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'cmpnMstPopup',
						value: data?.body.cmpnMstPopup || {}
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'opCodeList',
						value: data?.body.cmpnOpList || []
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'pmcIdList',
						value: data?.body.cmpnPmcList || []
					});
					commit(types.CMPN_MST_POPUP, {
						key: 'deleteBtn',
						value: true
					});

					if (data.body.cmpnMstPopup.causPartNm !== '' || data.body.cmpnMstPopup.causPartNm !== null) {
						commit(types.CMPN_MST_POPUP, {
							key: 'readOnlyAuth',
							value: true
						});
					}
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//교환부품정보 조회searchCmpnPartList
	getSearchCmpnPartList_({ commit, state }, param) {
		return api
			.getSearchCmpnPartList(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'cmpnPartList',
						value: data?.body.cmpnPartList || {}
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	//OP코드 팝업 조회
	getSearchOpCdList_({ commit, state }) {
		const { opCdSearchParams, popUpPagingInfo } = state;

		return api
			.getSearchOpCdList({ searchParams: opCdSearchParams, currentPage: popUpPagingInfo.currentPage, pageUnit: popUpPagingInfo.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'popUpOpCdList',
						value: data?.body.resultList || {}
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'popUpPagingInfo',
						value: data?.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	// 캠페인 상세 저장
	async saveCmpnMst_(store, { saveParams }) {
		return api
			.postCmpnMst({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				throw new Error(error.header.message);
			});
	},
	// 캠페인 상세 삭제
	async deleteCmpnMst_(store, { cmpnNo, deleteParams }) {
		try {
			const { header } = await api.postDeleteCmpnMst({ cmpnNo, deleteParams });
			return header;
		} catch (error) {
			throw new Error(error.header.message);
		}
	},
	// OP코드 팝업 그리드에서 추가버튼 클릭시
	addOpCdListRow_({ state, commit }) {
		const rowKey = getRowKey();
		const addedRow = {
			rowType: 'add',
			opCd: '', //op코드
			insnWay: '', //점검방법
			lts: '', //LTS
			mtrlCst: '', //자재비
			wags: '', //공임비
			incdCst: '' //부대비
		};
		const value = [...state.opCodeList, addedRow];
		commit(types.SET, { key: 'opCodeList', value });
		return addedRow;
	},
	// OP코드 목록에서 저장
	async saveOpCdList_({ commit }, { cmpnNo, saveRows }) {
		return api
			.postCmpnOpCdList({ cmpnNo, saveRows })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'opCodeList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw new Error(error.header.message);
			});
	},
	// OP코드 목록에서 삭제
	async deleteOpCdList_({ commit }, { cmpnNo, saveRows }) {
		return api
			.postDeleteCmpnOpCdList({ cmpnNo, saveRows })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'opCodeList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw new Error(error.header.message);
			});
	},
	// 교환부품정보 팝업 그리드에서 추가버튼 클릭시
	addPartListRow_({ state, commit }) {
		const rowKey = getRowKey();
		const addedRow = {
			rowType: 'add',
			partNo: '',
			partNm: '',
			rowKey
		};
		const value = [...state.cmpnPartList, addedRow];
		commit(types.SET, { key: 'cmpnPartList', value });
		return addedRow;
	},
	// 교환부품정보 목록에서 저장
	async savePartList_({ commit }, { cmpnNo, opCd, saveRows }) {
		return api
			.postCmpnPartList({ cmpnNo, opCd, saveRows })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'cmpnPartList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw new Error(error.header.message);
			});
	},
	// 교환부품정보 목록에서 삭제
	async deletePartList_({ commit }, { cmpnNo, opCd, saveRows }) {
		return api
			.postDeleteCmpnPartList({ cmpnNo, opCd, saveRows })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'cmpnPartList',
						value: data?.body || []
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw new Error(error.header.message);
			});
	},
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			//return error?.header;
			throw new Error(error?.header);
		}
	},
	//원인부품에 맞는 협력사 조회
	getPartCost_({ commit, state }, param) {
		return api
			.getPartCost(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.CMPN_MST_POPUP, {
						key: 'cpnyCd',
						value: data !== null && data !== undefined ? data.body.resultList[0].cpnyCd : null
					});
					commit(types.CMPN_MST_POPUP, {
						key: 'cpnyNm',
						value: data !== null && data !== undefined ? data.body.resultList[0].cpnyNm : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	}
};
